import axios from "axios";
import config from '../config';
import cognitoId from '../lib/cognitoId';
import {
  CognitoState
} from 'react-cognito';

const instance = axios.create({
  baseURL: config.apiUrl,
});

// const cognitoUser = cognitoId.getCognitoUser();

// Add a request interceptor

instance.interceptors.request.use(function (request) {
  let originalRequest = request;

  // originalRequest.params = {username: cognitoUser.username}
  const cognitoUser = cognitoId.getCognitoUser();
 
  // Get refresh token before refreshing session    
  return refreshToken().then((response) => {    
    originalRequest.headers['Authorization'] = response.signInUserSession.idToken.jwtToken;
    axios.defaults.headers.common['Authorization'] = response.signInUserSession.idToken.jwtToken;
    return Promise.resolve(originalRequest);
  })
  .catch(() => {
    // No logged-in user: don't set auth header
    return Promise.resolve(originalRequest)
  });
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

function refreshToken() {
  return new Promise((resolve, reject) => {    
    const verifySessionUser = new Promise((resolve, reject) => { resolve(cognitoId.verifySession()); });
    resolve(verifySessionUser);
  })
};

export default instance;


// WEBPACK FOOTER //
// ./src/services/axios-service.js